const c = {
  name: "Webhooks",
  dimensions: { width: 40, height: 37 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 37" style="enable-background:new 0 0 40 37;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.5,1.2c-4.3-2.5-9.8-1-12.3,3.3c-2.3,4-1.2,9.1,2.5,11.7l-4.6,7.9C9.7,24.1,9.4,24,9,24
			c-2.1,0-3.9,1.6-4,3.7c-0.1,1.5,0.6,3,2,3.8l0,0c1.3,0.7,2.7,0.7,3.9,0c0.6-0.3,1.2-0.9,1.6-1.5c0.4-0.7,0.6-1.5,0.5-2.3
			c-0.1-1-0.5-1.9-1.2-2.6l5.5-9.6l-0.9-0.5c-3.4-1.9-4.5-6.2-2.6-9.6c1.9-3.4,6.2-4.5,9.6-2.6c3.4,1.9,4.5,6.2,2.6,9.6l1.7,1
			C30.3,9.2,28.8,3.7,24.5,1.2z M7,28c0,0,0-0.1,0-0.1c0-0.3,0.1-0.6,0.3-0.8c0.6-1,1.8-1.3,2.7-0.7c0.6,0.3,0.9,0.9,1,1.6
			c0,0,0,0.1,0,0.1c0,1.1-0.9,2-2,2C7.9,30,7,29.1,7,28z"/>
		<path class="st0" d="M23.5,7C23.8,7.6,24,8.3,24,9c0,0.7-0.2,1.4-0.5,2c-0.2,0.3-0.4,0.6-0.6,0.8l4.6,7.9
			c4.1-1.8,9.1-0.3,11.4,3.7c2.5,4.3,1,9.8-3.3,12.3c-4.3,2.5-9.8,1-12.3-3.3l1.7-1c1.9,3.4,6.2,4.5,9.6,2.6
			c3.4-1.9,4.5-6.2,2.6-9.6c-1.9-3.4-6.2-4.5-9.6-2.6l-0.9,0.5l-5.5-9.6c-1,0.3-2.1,0.2-3.1-0.4l0,0c-1.4-0.8-2.1-2.2-2-3.7
			c0.1-1.3,0.8-2.6,2-3.3l0,0C19.9,4.4,22.4,5,23.5,7z M18.3,8C18.1,8.3,18,8.6,18,8.9l0,0l0,0l0,0c0,0.3,0.1,0.7,0.3,1
			c0.6,1,1.8,1.3,2.7,0.7c0.6-0.4,1-1,1-1.7c0-0.7-0.4-1.3-1-1.7C20,6.7,18.8,7,18.3,8z"/>
		<path class="st0" d="M0,28c0-5,4-9,9-9v2c-3.9,0-7,3.1-7,7s3.1,7,7,7c3.9,0,7-3.1,7-7v-1h11.1c0.4-1.7,2-3,3.9-3
			c0.8,0,1.5,0.2,2.1,0.6c1.2,0.7,1.9,2,1.9,3.4c0,2.2-1.8,4-4,4c-1.9,0-3.4-1.3-3.9-3h-9.2c-0.5,4.5-4.3,8-8.9,8C4,37,0,33,0,28z
			 M29,28c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2c0-0.7-0.4-1.4-1-1.7l0,0l0,0c-0.3-0.2-0.6-0.3-1-0.3C29.9,26,29,26.9,29,28z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Webhooks
};
